<template>
    <div class="w-full text-gray-1 text-center pb-5">
        <input
            id="otp_input"
            type="tel"
            :maxlength="maxLength"
            v-model="otp"
            class="w-full text-22 px-3 py-2 border placeholder-gray-2
                text-gray-1 rounded-lg text-center"
            :placeholder="inputLbl.name"
            @input="onChange()"
        />
        <div class="text-red-500 text-sm text-center" v-if="isError">
                {{getErrorMsg}}
        </div>
        <div class="text-red-500 text-sm text-center" v-if="invalidOtp">
                {{invalidOtpText}}
        </div>
    </div>
</template>
<script>
// helper
import Util from "@/helper/Utility.js";
import RegxHelper from '@/helper/RegxHelper.js';

export default {
    name: 'OtpInput',
    props: {
        // v-model
        inputOtp: { type: String, required: true },
        inputValid: { type: Boolean, required: true },
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        inputLbl:       { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        invalidOtp:     { type: String },
    },
    data: function () {
        return {
            otp: this.inputOtp,

        };
    },
    computed: {
        invalidOtpText: function() {
            return this.otp.length == 6 && this.invalidOtp !== "" ? this.invalidOtp : "";
        },
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        },
    },
    watch: {
        otp: function (newVal) {
            let result = newVal;
            result = RegxHelper.removeNotNumber(result);

            this.otp = result;
            this.$emit('update:inputOtp', result);
            this.$emit('update:inputValid', (result.length == 6));
        }
    },

    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.otp) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.otp.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
            }
        },
        onChange: function() {
            let result = this.otp;
            result = RegxHelper.removeNotNumber(result);

            this.otp = result;
            this.validateInput();
            this.$emit('update:inputOtp', result);
        },
        resetOtp: function(){
            this.otp = '';
        }
    }
}
</script>
<style lang="scss" scoped>
// #otp_input {
//     position: absolute;
//     top: 0;
//     left: -50000%;
// }
.input-otp-col {
    grid-template-columns: repeat(6, minmax(0px, 50px));
}
</style>

